import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  getReportFields as onGetReportFields
} from '../../actions/reportFieldsActions'

const mapStateToProps = state => ({
  reportFieldsDataState: state.reportFields.dataState,
  reportFieldsData: get(state, ['reportFields', 'data', 'fields'], null),
  reportFieldsErrors: get(state, ['reportFields', 'errors'], null),
  currentReportId: get(state, ['reportFields', 'currentId'], ''),
  currentReportType: get(state, ['reportFields', 'currentType'], ''),
  isReportFieldsCanceled: state.reportFields.isCanceled,
  cancelReportFields: state.reportFields.cancel
})

const mapDispatchToProps = {
  onGetReportFields
}

const withReportFields = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReportFields }